/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateTestDto
 */
export interface CreateUpdateTestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateTestDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateTestDto
     */
    fileName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateTestDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateTestDto
     */
    identifier?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateTestDto
     */
    active?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateTestDto
     */
    lp?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateTestDto
     */
    onlineOption: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateTestDto
     */
    needDevice: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateTestDto
     */
    withoutHarmfulFactors: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateTestDto
     */
    generateSupportingExamination: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateTestDto
     */
    averageDuration?: number | null;
}

/**
 * Check if a given object implements the CreateUpdateTestDto interface.
 */
export function instanceOfCreateUpdateTestDto(value: object): value is CreateUpdateTestDto {
    if (!('onlineOption' in value) || value['onlineOption'] === undefined) return false;
    if (!('needDevice' in value) || value['needDevice'] === undefined) return false;
    if (!('withoutHarmfulFactors' in value) || value['withoutHarmfulFactors'] === undefined) return false;
    if (!('generateSupportingExamination' in value) || value['generateSupportingExamination'] === undefined) return false;
    return true;
}

export function CreateUpdateTestDtoFromJSON(json: any): CreateUpdateTestDto {
    return CreateUpdateTestDtoFromJSONTyped(json, false);
}

export function CreateUpdateTestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateTestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'description': json['description'] == null ? undefined : json['description'],
        'identifier': json['identifier'] == null ? undefined : json['identifier'],
        'active': json['active'] == null ? undefined : json['active'],
        'lp': json['lp'] == null ? undefined : json['lp'],
        'onlineOption': json['onlineOption'],
        'needDevice': json['needDevice'],
        'withoutHarmfulFactors': json['withoutHarmfulFactors'],
        'generateSupportingExamination': json['generateSupportingExamination'],
        'averageDuration': json['averageDuration'] == null ? undefined : json['averageDuration'],
    };
}

export function CreateUpdateTestDtoToJSON(value?: CreateUpdateTestDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'fileName': value['fileName'],
        'description': value['description'],
        'identifier': value['identifier'],
        'active': value['active'],
        'lp': value['lp'],
        'onlineOption': value['onlineOption'],
        'needDevice': value['needDevice'],
        'withoutHarmfulFactors': value['withoutHarmfulFactors'],
        'generateSupportingExamination': value['generateSupportingExamination'],
        'averageDuration': value['averageDuration'],
    };
}

